import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer'
import { mapperGlobalDataTheme } from '../../../../core/data-layer/global-data/mappers'
import { mapperModuleCampaignsMetricsItem } from '../../modules/module-campaigns-metrics-item/mapper-module-campaigns-metrics-item'
import type { MapperModuleCampaignsMetricsItemData } from '../../modules/module-campaigns-metrics-item/mapper-module-campaigns-metrics-item'

import type { Block } from '@contentful/rich-text-types'

type MapperBlockCampaignsMetricsData = {
  sys?: { id?: string }
  title?: string
  contentType?: string
  description?: { json: Block }
  itemsCollection?: { items: MapperModuleCampaignsMetricsItemData[] }
  landscapeOrientation: boolean
  theme?: { theme: string }
}

type MapperCampaignsMetricsReturnType = null | {
  id: string
  title: string
  contentType: string
  description: string
  items: ReturnType<typeof mapperModuleCampaignsMetricsItem>[]
  orientation: 'horizontal' | 'vertical'
  theme: string | null
}

export const mapperBlockCampaignsMetrics = (
  data: MapperBlockCampaignsMetricsData
): MapperCampaignsMetricsReturnType => {
  if (!data) {
    return null
  }

  return {
    id: data.sys?.id || '',
    title: data.title || '',
    contentType: data.contentType || '',
    // @TODO: Update DsStatsBlock component to support Rich Text in the subtitle
    description: data?.description ? documentToPlainTextString(data.description.json) : '',
    items: data.itemsCollection ? data.itemsCollection.items.map(mapperModuleCampaignsMetricsItem) : [],
    orientation: data.landscapeOrientation ? 'horizontal' : 'vertical',
    theme: mapperGlobalDataTheme(data.theme)?.theme || null
  }
}
